import {ModuleComponent} from "../../js/module-component";
import Swiper from 'swiper/bundle';
// import Swiper and modules styles
export class ModVideo extends ModuleComponent{
    ready() {
        super.ready();
        const $video = this.findMember("video");
        const $videoImg = this.findMember("video-img");

        $videoImg.click(
            (ev) => {
                const $player = $($video.data("video-player"));
                $player.attr("width",$videoImg.width());
                $player.attr("height",$videoImg.height());
                $player.attr("autoplay",true);
                $player.attr("controls",true);
                $video.html($player);
            }
        );

        this.findMember("video-out-img").click(
            (ev) => {
                const videoElement = document.querySelector('.video-player');
                if (videoElement.paused) {
                    videoElement.play();
                } else {
                    videoElement.pause();
                }
            }
        );
    }
}
